import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input", "text",
    "gradient", "gradientToggle",
    "colorSelect",
    "bgInput", "background",
    "logoInput", "logo",
    "colorInput", "button",
    "watermarkLight", "watermarkDark",
    "bgPositionX"
  ]

  connect() {
    this.toggleGradient()
    this.updateWatermark()
  }

  updateText() {
    const value = this.inputTarget.value

    this.textTarget.textContent = value
  }

  toggleGradient() {
    if (!this.hasGradientToggleTarget || !this.hasGradientTarget) return
    const checked = this.gradientToggleTarget.checked

    this.gradientTarget.classList.toggle("d-md-none", !checked)
  }

  updateColor() {
    if (!this.hasColorInputTarget || !this.hasButtonTarget) return

    this.buttonTarget.style.backgroundColor = this.colorInputTarget.value
  }

  updateBackground(event) {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()

    reader.onload = (e) => {
      this.backgroundTarget.style.backgroundImage = `url(${e.target.result})`
    }

    reader.readAsDataURL(file)
  }

  updateBgPositionX() {
    const value = this.bgPositionXTarget.value

    this.backgroundTarget.style.backgroundPosition = `center ${value}`
  }

  updateLogo(event) {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()

    reader.onload = (e) => {
      this.logoTarget.src = e.target.result
    }

    reader.readAsDataURL(file)
  }

  updateWatermark() {
    const color = this.colorSelectTarget.value;

    if (!this.hasColorSelectTarget) return

    this.watermarkLightTarget.classList.toggle("d-none", color !== "light")
    this.watermarkDarkTarget.classList.toggle("d-none", color !== "dark")
  }
}